/**
 * Check if the entire page is excluded.
 *
 * This class can be attached to the body element by ad ops via GTM.
 */
export const isPageExcluded = () => document.body.classList.contains('js-no-ad-refresh');
